import React, { Component } from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";

class UIModel extends Component {
  renderSizeClassName(baseClassName, modalSize) {
    switch (modalSize) {
      case "small":
        return ` ${baseClassName}-sm`;
      case "large":
        return ` ${baseClassName}-lg`;
      case "extra-large":
        return ` ${baseClassName}-xl`;
      case "xxl":
        return ` ${baseClassName}-xxl`;
      default:
        return ` ${baseClassName}-width: 60% !important`;
    }
  }

  renderClassName(modalSize, className) {
    const baseClassName = "modal";
    if (className) {
      return `${this.renderSizeClassName(
        baseClassName,
        modalSize
      )} ${className}`;
    }
    return `${this.renderSizeClassName(baseClassName, modalSize)}`;
  }

  render() {
    const {
      header,
      children,
      isOpen,
      showFooter,
      handleClose,
      modalSize,
      className,
    } = this.props;

    return (
      <Modal
        isOpen={isOpen}
        className={this.renderClassName(modalSize, className)}>
        {/* <ModalHeader toggle={handleClose}> */}
        <ModalHeader toggle={handleClose} close={<button className="close" onClick={handleClose}>&times;</button>}>
          {header}</ModalHeader>
        <ModalBody>{children}</ModalBody>
        {showFooter && <ModalFooter></ModalFooter>}
      </Modal>
    );
  }
}

export default UIModel;
